export { default as IconSVG } from './IconSVG';
export { default as TabNav } from './TabNav';
export { default as TechCoachCTA } from './TechCoachCTA';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/components/index.ts